<template>
  <div style="display: flex; justify-content: space-between">
    <el-tree
        :data="areaList"
        show-checkbox
        node-key="label"
        ref="tree"
        :default-checked-keys="defaultList"
        :props="defaultProps">
    </el-tree>
    <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
  </div>
</template>

<script>
import { areaList, addRecommendCity, updateRecommendCityDel } from "@/api/url";
import { postFormData, getFormData } from "@/api/api";
export default {
name: "addCityDialog",
  props: {
    value: Object,
  },
  data() {
   return {
     cityList: this.value.cityList,
     areaList: [],
     defaultProps: {
       children: 'cityList',
       label: 'label'
     },
     loading: false,
   }
  },
  computed: {
    defaultList() {
      let arr = []
      this.cityList.map(item=> {
        arr.push(item.city)
      })
      return arr
    }
  },
  methods: {
    getAreaList () {
      getFormData( areaList ).then((data) => {
        if (data.code == 200) {
          this.areaList = data.data;
          this.areaList.map(item => {
            item.label = item.province
            for(let i = 0; i < item.cityList.length; i++) {
              item.cityList[i].label = item.cityList[i].city
            }
          })
        }
      })
    },

    //获取提交参数
    getChecked() {
      let cityArray = [];
      let arr = this.$refs.tree.getCheckedNodes();
      // console.log(arr)
      arr.forEach((e) => {
        if(!e.cityList) {
          cityArray = cityArray.concat(e.label);
        }
      });
      return cityArray;
    },

    delCity(idx,id) {
      let param = {}
      param['id'] = id
      postFormData(updateRecommendCityDel, param).then((data) => {
        if(data.code == 200) {
          this.cityList.splice(idx, 1)
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
      })
    },


    submit() {
      this.loading = true;
      let checkCitys = this.getChecked()
      for(let i=0; i<this.cityList.length; i++) {
        if(checkCitys.indexOf(this.cityList[i].city) == -1) {
          this.delCity(i,this.cityList[i].id)
        }
      }
      let param = {}
      param['cityArr'] = checkCitys
      postFormData(addRecommendCity, param).then((data)=>{
        if(data.code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: data.msg,
            type: 'warning'
          })
        }
        this.loading = false
      })
    }

  },
  mounted() {
    this.getAreaList()
  }
}
</script>

<style scoped>

</style>
